import React, { useEffect, useState } from "react";
import "./Header.scss"
import { logo } from "../../Assets";
import { Link } from "react-router-dom";
import { CiMenuBurger } from 'react-icons/ci'
import { useLocation } from "react-router-dom";

// BT Logo Animation Component
function BTLogo() {
  const [paused, setPaused] = useState(false);

  const toggleAnimation = () => {
    setPaused(!paused);
  };

  return (
    <button 
      onClick={toggleAnimation}
      aria-label="BT loading animation" 
      title={paused ? 'Paused — click to resume' : 'Click to pause'}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        zIndex: 30
      }}
    >
      <svg 
        viewBox="0 0 300 200" 
        aria-hidden="true" 
        role="img"
        style={{
          width: '75px',
          height: '50px'
        }}
      >
        {/* Base outline - white color - B */}
        <text 
          className="bt-base" 
          x="80" 
          y="120"
          style={{
            fill: 'none',
            stroke: '#ffffff',
            strokeWidth: '5',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '700',
            fontSize: '120px',
            textAnchor: 'middle',
            dominantBaseline: 'middle'
          }}
        >
          B
        </text>
        
        {/* Base outline - white color - T */}
        <text 
          className="bt-base" 
          x="170" 
          y="120"
          style={{
            fill: 'none',
            stroke: '#ffffff',
            strokeWidth: '5',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '700',
            fontSize: '120px',
            textAnchor: 'middle',
            dominantBaseline: 'middle'
          }}
        >
          T
        </text>
        
        {/* Animated loop - golden color - B (starts first) */}
        <text 
          className="bt-loop-b" 
          x="80" 
          y="120"
          style={{
            fill: 'none',
            stroke: '#f7c651',
            strokeWidth: '6',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '700',
            fontSize: '120px',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            strokeDasharray: '300',
            strokeDashoffset: paused ? '300' : '300',
            animation: paused ? 'none' : 'bt-outline-dash 3s linear infinite'
          }}
        >
          B
        </text>
        
        {/* Animated loop - golden color - T (starts after delay) */}
        <text 
          className="bt-loop-t" 
          x="170" 
          y="120"
          style={{
            fill: 'none',
            stroke: '#f7c651',
            strokeWidth: '6',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '700',
            fontSize: '120px',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            strokeDasharray: '300',
            strokeDashoffset: paused ? '300' : '300',
            animation: paused ? 'none' : 'bt-outline-dash 3s linear infinite 0.8s'
          }}
        >
          T
        </text>
      </svg>
    </button>
  );
}

const Header = () =>{
    const [url,setUrl] = useState();
    const location = useLocation();
    const [nav,setNav] = useState(false);
    
    useEffect(() => {
      setUrl(location.pathname);
    }, [location.pathname]);
    return(
        <div className={`Header ${url === '/LRP' ? 'feedback-header' : ''}`}>
            <div className="logo">
                {url === '/LRP' ? <BTLogo /> : <img src={logo} alt="logo"/>}
            </div>
            <ul>
                 <Link to="/" className={url === "/" ? "focus" :""}>Home</Link>    
                 <Link to="/Program" className={url === "/Program" ? "focus" :""}>Online Programs</Link>
                 {/* <Link to="/Product" className={url === "/Product" ? "focus" :""}>Product</Link> */}
                 <Link to="/Achievements" className={url === "/Achievements" ? "focus" :""}>Achievements</Link>
                 <Link to="/Placement" className={url === "/Placement" ? "focus" :""}>Placements</Link>
                 <Link to="/Students" className={url === "/Students" ? "focus" :""}>Students</Link>
                 <Link to="/About" className={url === "/About" ? "focus" :""}>About us</Link>
                
            </ul>
            <div className="mob">
                <CiMenuBurger size={30} onClick={()=>setNav((prev)=>!prev)}/>
                {
                    nav?
                    <div className="MobNav">
                        <ul>
                         <Link to="/" className={url === "/" ? "mobFocus" :""}>Home</Link>    
                         <Link to="/Program" className={url === "/Program" ? "mobFocus" :""}>Online Programs</Link>
                         {/* <Link to="/Product" className={url === "/Product" ? "mobFocus" :""}>Product</Link> */}
                         <Link to="/Achievements" className={url === "/Achievements" ? "mobFocus" :""}>Achievements</Link>
                         <Link to="/Placement" className={url === "/Placement" ? "mobFocus" :""}>Placements</Link>
                         <Link to="/Students" className={url === "/Students" ? "mobFocus" :""}>Students</Link>
                         <Link to="/About" className={url === "/About" ? "mobFocus" :""}>About us</Link>
                        </ul>
                    </div>:
                    null
                }
            </div>
        </div>
    )
}

export default Header